const GA_ID = process.env.REACT_APP_GA_ID;

let lastPath = null;

export function trackPage(path) {
  if (!window.gtag || !GA_ID || path.startsWith("/admin") || path === lastPath) return;
  lastPath = path;
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag || !GA_ID || window.location.pathname.startsWith("/admin")) return;
  window.gtag("event", name, params);
}
